import React, { useEffect, useRef, useState } from 'react';
import { GestureResponderEvent, Image, PixelRatio, StyleSheet, Text, TouchableOpacity, TouchableOpacityProps, View } from 'react-native';
import { useHover } from 'react-native-web-hooks';
import Game from '../../../shell/Game';
import ImageClass from '../../../shell/Image';
import { WaitForLoadImage } from '../../../shell/ImageHandler/WaitForLoadImage';
import useFontSize from '../../../shell/hooks/useFontSize';
import { TimageINT } from '../../../store/slices/gameObjectSlice';
import { TGallery } from './gallery/Gallery';
import { TScenesReplay } from './replayScenes/ScenesReplay';
interface GalleryButtonProps {
    scene: TScenesReplay | TGallery;
}

export const GalleryButton: React.FC<GalleryButtonProps & TouchableOpacityProps> = React.memo(({ scene, ...rest }) => {
    const ref = useRef(null);
    const isHovered = useHover(ref);
    const isUnmounted = useRef(false);
    const [image, setImage] = useState<TimageINT>();
    const styles = StyleSheet.create({
        container: {
            width: "33%",
            marginTop: 7,
            transform: [{ scale: isHovered ? 1.1 : 1 }],
            zIndex: isHovered ? 5 : 1,
        },
        containerHover: {
            opacity: 1,
        },
        buttonStyle: {
            width: "100%",
            height: "100%"
        },
        imageContainer: {
            flex: 4,
            width: "100%",
            height: "100%"
        },
        images: {
            width: "100%",
            height: "100%",
            aspectRatio: 16 / 9
        },
        emptyImage: {
            width: "100%",
            height: "100%",
            backgroundColor: "gray"
        },
        textContainer: {
            height: useFontSize(2.5),
        },
        buttonText: {
            alignSelf: "center",
            alignItems: "center",
            color: "white",
            fontSize: useFontSize(1.5),
            alignContent: "center",



        }, saveSlot: {
            aspectRatio: 16 / 9,

        },
        pencilIcon: {
            position: "absolute",
            color: "white",
            padding: 10 / PixelRatio.get(),
        },
        timesIcon: {
            position: "absolute",
            color: "white",
            padding: 10 / PixelRatio.get(),
            right: 0

        },
        imageStyle: {
            width: "100%",
            height: "100%",
        }

    });

    useEffect(() => {
        if (scene && !isUnmounted.current) {
            setImage(ImageClass._globalImages.get(scene.imageKey)?.poster || ImageClass._globalImages.get(scene.imageKey));
        }

        return () => {
            isUnmounted.current = true;
        };
    }, [scene]);

    const onPressed = (e: GestureResponderEvent) => {

        rest?.onPress?.(e);

    };
    return (
        <View style={styles.container} >
            {Game.isReplayRunning ? <View ref={ref} style={[styles.saveSlot, { borderWidth: 4, borderColor: isHovered ? "whitesmoke" : "#b4a4a4", margin: 2, height: "100%" }]}></View> :
                <View>
                    <View style={styles.saveSlot}>
                        <View style={[{ borderWidth: 4, borderColor: isHovered ? "whitesmoke" : "#b4a4a4", margin: 2, height: "100%" }]}>
                            <TouchableOpacity activeOpacity={scene.seen ? 0.2 : 1} onPress={(e) => onPressed(e)} ref={ref} style={[styles.buttonStyle, isHovered && styles.containerHover,]}>
                                <View style={styles.imageContainer}>
                                    {/* <WaitForLoadImage blurRadius={scene.seen ? 0 : 8} style={styles.imageStyle} source={image?.url}></WaitForLoadImage> */}
                                    <WaitForLoadImage blurRadius={scene.seen ? 0 : 50}
                                        partials={image?.partial ? [<Image key={image?.key} source={image?.url} style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                        }} resizeMode={'cover'} ></Image >] : undefined}
                                        disableAnimation source={image?.parent?.url || image?.url} style={{ width: "100%", height: "100%", position: "absolute" }} />
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={styles.textContainer}>
                        <Text selectable={false} adjustsFontSizeToFit={true} numberOfLines={1} style={styles.buttonText}> {scene.text}</Text>
                    </View>
                </View>

            }
        </View >
    );
});